import { retrieveErrorFromApi } from '../../../helper'
import { logger } from '../../../logger/logger'
import { setReceiptIsLoading } from '../../action/receipt'
import { setAppErrors } from '../../action/system'
import getReceipt from '../../axios/receipt/get'

export const getReceiptThunk = (companyIndex, orderPublicId) => dispatch => {
	return getReceipt(companyIndex, orderPublicId)
		.then(res => {
			logger.info('Get digital receipt ', orderPublicId)
			if (res.data?.[0]?.orderId) {
				dispatch(setReceiptIsLoading(false))
			}
		}).catch(error => {
			dispatch(setAppErrors(retrieveErrorFromApi(error)))
		})
}
